// Angular Imports
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
// Angular Material Imports
import { MatRippleModule } from '@angular/material/core'
import { MatTooltipModule } from '@angular/material/tooltip'
// Shared Imports
import { EButtonColor, TTooltipPosition } from '@shared/models'

@Component({
	selector: 'app-button',
	standalone: true,
	imports: [MatRippleModule, MatTooltipModule],
	templateUrl: './button.component.html',
	styleUrls: ['./button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
	@Input() color: keyof typeof EButtonColor = EButtonColor.green
	@Input() outline: boolean = false
	@Input() hasIcon: boolean = false
	@Input() isDisabled: boolean = false
	@Input() isFull: boolean = false
	@Input() hasTooltip: string = ''
	@Input() tooltipPosition: TTooltipPosition = 'below'
	@Output() clicked = new EventEmitter<void>()

	readonly EButtonColor = EButtonColor

	emitClick() {
		this.clicked.emit()
	}
}
